import React from 'react';

export const GridLinkButton = ({ children, onClick, ...rest }) => {
  return (
    <button className="btn btn-link p-0 border-0" style={{ verticalAlign: 'top' }} onClick={onClick}>
      {children}
    </button>
  );
};

